import { useCallback, useEffect, useState } from 'react';
import { useTrackingState } from 'contexts/TrackingProvider';
import { useUserMarketingAgreementMutation } from 'queries/account/useUserMarketingAgreementMutation';
import { showToast } from 'utils/modal';
import { useGetUserMarketingAgreementQuery } from 'queries/account/useGetUserMarketingAgreementQuery';

export const useMarketingAgree = () => {
  const { tracker } = useTrackingState();

  const { data: marketingAgreementData } = useGetUserMarketingAgreementQuery();
  const [marketingAgree, setMarketingAgree] = useState({
    agree: !!marketingAgreementData?.userMarketingAgreement.agree,
    agreeNight: !!marketingAgreementData?.userMarketingAgreement.agreeNight,
  });
  useEffect(
    () =>
      setMarketingAgree({
        agree: !!marketingAgreementData?.userMarketingAgreement.agree,
        agreeNight: !!marketingAgreementData?.userMarketingAgreement.agreeNight,
      }),
    [marketingAgreementData],
  );

  const { mutate: userMarketingAgreementMutate } = useUserMarketingAgreementMutation({
    onSuccess: ({ userMarketingAgreement }) => {
      const { agree } = userMarketingAgreement;
      const agreeAt = new Date(userMarketingAgreement.agreeAt);
      const dateStr = `${agreeAt.getFullYear()}년 ${agreeAt.getMonth() + 1}월 ${agreeAt.getDate()}일`;
      const result = agree ? '수신동의' : '수신동의 해지';

      tracker.trackMktAgreement(userMarketingAgreement);
      showToast(`${dateStr}에 ${result} 처리되었어요.`);
    },
    onError: () => {
      setMarketingAgree({
        agree: !!marketingAgreementData?.userMarketingAgreement.agree,
        agreeNight: !!marketingAgreementData?.userMarketingAgreement.agreeNight,
      });
      showToast('일시적인 오류로 마케팅 수신 동의 내역이 반영되지 않았어요. 잠시 뒤 다시 시도해주세요.');
    },
  });

  const { mutate: userNightMarketingAgreementMutate } = useUserMarketingAgreementMutation({
    onSuccess: ({ userMarketingAgreement }) => {
      const { agreeNight } = userMarketingAgreement;
      const agreeNightAt = new Date(userMarketingAgreement.agreeNightAt);
      const dateStr = `${agreeNightAt.getFullYear()}년 ${agreeNightAt.getMonth() + 1}월 ${agreeNightAt.getDate()}일`;
      const result = agreeNight ? '수신동의' : '수신동의 해지';

      tracker.trackMktAgreement(userMarketingAgreement);
      showToast(`${dateStr}에 ${result} 처리되었어요.`);
    },
    onError: () => {
      setMarketingAgree({
        agree: !!marketingAgreementData?.userMarketingAgreement.agree,
        agreeNight: !!marketingAgreementData?.userMarketingAgreement.agreeNight,
      });
      showToast('일시적인 오류로 마케팅 수신 동의 내역이 반영되지 않았어요. 잠시 뒤 다시 시도해주세요.');
    },
  });

  const handleChangeMarketingAgree = useCallback(() => {
    const next = marketingAgree.agree ? { agree: false, agreeNight: false } : { agree: true, agreeNight: false };
    setMarketingAgree(next);
    userMarketingAgreementMutate(next);
  }, [marketingAgree, userMarketingAgreementMutate]);

  const handleChangeNightMarketingAgree = useCallback(() => {
    const next = marketingAgree.agreeNight ? { agree: true, agreeNight: false } : { agree: true, agreeNight: true };
    setMarketingAgree(next);
    userNightMarketingAgreementMutate(next);
  }, [marketingAgree.agreeNight, userNightMarketingAgreementMutate]);

  return {
    marketingAgree,
    handleChangeMarketingAgree,
    handleChangeNightMarketingAgree,
  };
};
